export class Renseignements {

	public rensgComplt: string;

	public idMarche: string;

	constructor() { 
		 		this.rensgComplt = '';
		this.idMarche = '';
 
	}
}
